import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../config/api';
import { HOME } from '../../routes/paths';
import './Signin.css';

const Signin = ({ eventCode }) => {
  const [mobileNumber, setMobileNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Get URL search parameters to handle redirect after authentication
  const [searchParams] = useSearchParams();
  const pageParam = searchParams.get('redirect-to');

  const validateMobileNumber = (number) => {
    // Basic validation for mobile number (10 digits)
    const mobileRegex = /^[0-9]{10}$/;
    return mobileRegex.test(number);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!validateMobileNumber(mobileNumber)) {
      setError('Please enter a valid 10-digit mobile number');
      return;
    }

    setLoading(true);

    try {
      const response = await api.post('/users/signin', {
        mobile_number: mobileNumber
      });

      if (response.data.status === 'SUCCESS') {
        // Store mobile number and event code for OTP page
        localStorage.setItem('tempMobileNumber', mobileNumber);
        if (eventCode) {
          localStorage.setItem('eventCode', eventCode);
        } else {
          localStorage.removeItem('eventCode');
        }
        
        // Navigate to OTP verification page with page parameter if available
        const otpUrl = eventCode && pageParam ? `/auth/verify-otp?redirect-to=${encodeURIComponent(pageParam)}` : '/auth/verify-otp';
        navigate(otpUrl);
      } else {
        setError('Failed to send OTP. Please try again.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>

      <div className="signin-container">
        <div className="signin-card">
        <h2>{eventCode ? 'Join Event' : 'Welcome to Click AI'}</h2>
        <p>Enter your mobile number to receive a one-time verification code.</p>
        
        <form onSubmit={handleSubmit} className="signin-form">
          <div className="form-group">
            <label htmlFor="mobileNumber">Mobile Number</label>
            <div className="signin-phone-field" data-invalid={Boolean(error)} aria-busy={loading}>
            <span id="signin-country-code" className="signin-country-code" aria-label="Country code +91">+91</span>
            <input
              type="tel"
              inputMode="numeric"
              autoComplete="tel-national"
              aria-describedby={error ? "signin-country-code signin-phone-hint signin-error" : "signin-country-code signin-phone-hint"}
              aria-invalid={Boolean(error)}
              disabled={loading}
              id="mobileNumber"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value.replace(/\D/g, '').slice(0, 10))}
              placeholder="Mobile number"
              maxLength="10"
              required
            />
            </div>
            <p id="signin-phone-hint" className="signin-phone-hint">Enter your 10-digit mobile number.</p>
          </div>

          {error && <div id="signin-error" className="error-message" role="alert">{error}</div>}

          <button 
            type="submit" 
            className="submit-btn"
            disabled={loading || mobileNumber.length !== 10}
          >
            {loading ? 'Sending...' : 'Send OTP'}
          </button>
        </form>
        {!eventCode && <Link className="signin-home-link" to={HOME}>Back to home</Link>}
        </div>
      </div>
    </>
  );
};

export default Signin;
